import MqUtils from '../common/utils/mq.es6';
import AnimeUtils from '../common/utils/anime.es6';

export default class MainMv {
    constructor(main) {
        this.main = main;

        this.$mainMv = {
            canvas: document.querySelector('.js-canvas'),
            logo: document.querySelector('.js-main_mv__logo'),
            date: document.querySelector('.js-main_mv__date'),
            icons: document.querySelector('.js-main_mv__icons'),
        };
    }

    setAnimate() {
        const hasAllEls = Object.values(this.$mainMv).every(($el) => $el);

        // PC幅または全要素を取得できていない場合、実行不可
        if (MqUtils.getMq('wide').matches || !hasAllEls) return;

        const animations = {
            canvas: AnimeUtils.getOutBack(this.$mainMv.canvas, 10, 2400, 1600),
            logo: AnimeUtils.getBounce(this.$mainMv.logo, 40, 1200, 400),
            date: AnimeUtils.getBounce(this.$mainMv.date, 20, 1200, 600),
            icons: AnimeUtils.getBounce(this.$mainMv.icons, 10, 1200, 800),
        };

        animations.logo.onfinish = () => this.setAnimationEnd();
    }

    setAnimationEnd() {
        document.body.classList.add('-animationEnd');
        this.main.scroll.setScrollReveal();

        // メインKV・バナーの自動再生を開始
        const { swipers } = this.main.slider;
        swipers.mainKv.autoplay.start();
        swipers.bnr.autoplay.start();
    }
}
